<template>
    <div>
    <el-dialog
        :visible.sync="editorShow" 
        :title="title" 
        :close-on-click-modal="false"
        width="750px" 
        ref="dialog" 
        @close="editorClose"
    >
        <el-form inline label-width="100px" ref="messageForm">
            <el-form-item label="弹窗名称：" required>
                <el-input size="medium" v-model="form.Title" placeholder="请输入弹窗名称" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="弹窗类型：" required>
                <el-select size="medium" v-model="form.DialogsType" placeholder="请选择弹窗类型" style="width: 600px;">
                    <el-option :value="item.value" :label="item.label" v-for="(item, index) in MESSAGE_TYPE.MESSAGEEBOXTYPE" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提醒内容：" required>
                <el-input 
                    type="textarea" 
                    :autosize="{minRows: 2}"
                    v-model="form.Content" 
                    style="width: 600px;" 
                    placeholder="请输入内容以#隔开（例：您的权限被限制，请联系客服400-1100-243）"
                ></el-input>
            </el-form-item>
            <el-form-item label="弹窗页面：" required>
                <el-select size="medium" v-model="form.DialogsPage" placeholder="请选择弹窗页面" style="width: 600px;">
                    <el-option :value="2" label="首页"></el-option>
                    <el-option :value="3" label="接单列表页"></el-option>
                    <el-option :value="1" label="全局"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="弹窗场景：" required>
                <el-select size="medium" v-model="form.SceneCode" placeholder="请选择弹窗场景" style="width: 600px;">
                    <el-option :value="item.Value" :label="item.Description" v-for="(item, index) in sceneCodeList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提醒频率：" required>
                <div class="item-flex-block" style="width: 600px;">
                    <el-select size="medium" v-model="form.Period" placeholder="请选择提醒频率" style="width: 270px;">
                        <el-option :value="item.value" :label="item.label" v-for="(item, index) in MESSAGE_TYPE.FREQUENCY" :key="index"></el-option>
                    </el-select>
                    <template v-if="form.Period != 1 && form.Period != 6 && form.Period !== ''">
                        <div class="position-right-i">
                            <el-input size="medium" v-model="form.RemindCount" placeholder="提醒多少" style="width: 270px;"></el-input>
                            <i>次</i>
                        </div>
                    </template>
                </div>
            </el-form-item>
            <el-form-item label="站点：" required>
                <el-checkbox v-model="form.AppIsRemind" style="margin-right: 60px;">APP</el-checkbox>
                <el-checkbox v-model="form.PcIsRemind" style="margin-right: 60px;">PC</el-checkbox>
                <el-checkbox v-model="form.WxIsRemind">微信站</el-checkbox>
            </el-form-item>
            <el-form-item label="存在时长：">
                <div class="item-flex-block" style="width: 600px;">
                    <el-date-picker
                        style="width: 270px;"
                        size="medium"
                        v-model="form.StartTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始时间">
                    </el-date-picker>
                    <el-date-picker
                        style="width: 270px;"
                        size="medium"
                        v-model="form.EndTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束时间">
                    </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="交互功能：" required>
                <el-input size="medium" v-model="form.ConfirmBtnText" placeholder="交互功能命名（例：确定）" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="取消交互：">
                <el-input size="medium" v-model="form.CancelBtnText" placeholder="取消交互功能命名（例：取消）" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="配图：" required v-if="form.AppIsRemind || form.PcIsRemind || form.WxIsRemind">
                <div class="item-flex-block" style="width: 600px;justify-content: flex-start;">
                    <template v-if="form.AppIsRemind || form.WxIsRemind">
                        <div style="margin-right: 100px">
                            <p style="text-align: center;margin-top: 0;">app及微信站</p>
                            <el-upload
                                class="show"
                                :class="{hide:hideUploadApp}"
                                :action="url"
                                list-type="picture-card"
                                :limit="1"
                                :file-list="fileListApp"
                                :on-change="dealImgChangeApp"
                                :on-remove="handleDealImgRemoveApp"
                                :on-success="handleAvatarSuccessApp"
                                :on-preview="handlePictureCardPreview"
                                accept=".jpg, .jpeg, .png"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </template>
                    <template v-if="form.PcIsRemind">
                        <div>
                            <p style="text-align: center;margin-top: 0;">PC</p>
                            <el-upload
                                class="show"
                                :class="{hide:hideUploadPc}"
                                :action="url"
                                list-type="picture-card"
                                :limit="20"
                                :file-list="fileListPc"
                                :on-change="dealImgChangePc"
                                :on-remove="handleDealImgRemovePc"
                                :on-success="handleAvatarSuccessPc"
                                :on-preview="handlePictureCardPreview"
                                accept=".jpg, .jpeg, .png"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </template>
                </div>
            </el-form-item>
            <el-form-item label=" ">
                <el-button size="medium" @click="onSubmit(2)" :loading="submitAllLoading">保存</el-button>
                <el-button size="medium" type="primary" @click="onSubmit(1)" :loading="submitAllLoading">启用</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    </div>
</template>

<script>
import { MESSAGE_TYPE } from '@/config/const/common.js'
import apiEnv from '@/service/apiEnv.js'
import {
    addDialogsConfig,           //新增弹窗配置
    updateDialogsConfig,        //编辑弹窗配置
    listEnumItem,               //获取弹窗场景
} from "@/service/message";
export default {
  data() {
    return {
        MESSAGE_TYPE,
        url: apiEnv.uploadURL,

        title: '',
        editorShow: false,
        hideUploadApp: false,
        hideUploadPc: false,
        limitCount: 1,
        fileListApp: [],
        fileListPc: [],
        form: {
            Title: '',      //弹窗标题
            DialogsType: '',    //弹窗类型
            Content: '',        //提醒内容
            DialogsPage: '',    //弹窗页面
            SceneCode: '',      //弹窗场景
            Period: '',         //提醒频率
            RemindCount: '',    //提醒次数
            AppIsRemind: false,     //App是否选中
            PcIsRemind: false,     //PC是否选中
            WxIsRemind: false,     //微信是否选中
            StartTime: '',      //开始时间
            EndTime: '',        //结束时间
            ConfirmBtnText: '', //交互功能
            CancelBtnText: '',  //取消交互功能
            PcDialogsImageUrl: '', //pc配图
            MobileDialogsImageUrl: '', //app配图
        },
        oraginForm:{},



        dialogImageUrl: '',
        dialogVisible: false,

        isEditor: false,    //是否编辑
        submitAllLoading: false,   //按钮loading

        sceneCodeList: [],          //弹窗场景列表
    }
  },
  methods: {
    open(details) {
        this.listEnumItemFun();
        this.oraginForm = Object.assign({}, this.form)
        // let api = process.env.NODE_ENV == 'development' ? '/api1' : process.env.VUE_APP_API1;
        // this.url = api + '/api/Upload/UploadNoWatermarkImg';
        if(!details) {
            this.title = '添加'
            this.isEditor = false
        }else {
            this.title = '编辑'
            this.isEditor = true
            this.$nextTick(()=>{
                let objApp = {}
                let objPc = {}
                if(details.MobileDialogsImageUrl) {
                    objApp.url = details.MobileDialogsImageUrl
                    this.fileListApp.push(objApp)
                    this.hideUploadApp = true
                }
                if(details.PcDialogsImageUrl) {
                    objPc.url = details.PcDialogsImageUrl
                    this.fileListPc.push(objPc)
                    this.hideUploadPc = true
                }
                this.form = Object.assign({}, details)
                this.form.RemindCount = this.form.RemindCount === 0? '' : this.form.RemindCount;
            })
        }
        this.editorShow = true
        
    },
    //关闭
    editorClose() {
        this.handleReset();
        this.editorShow = false
    },
    dealImgChangeApp(file, fileList){
        this.hideUploadApp = fileList.length >= this.limitCount;
    },
    //上传成功app
    handleAvatarSuccessApp(res, file ,fileList) {
        if(res.Result != 1) {
            this.fileListApp = [];
            return this.$message.error(res.Message)
        }
        this.fileListApp = fileList;
        this.form.MobileDialogsImageUrl = res.Data[0].imgUrl;
    },
    //删除上传文件app
    handleDealImgRemoveApp(file, fileList){
        this.hideUploadApp = fileList.length >= this.limitCount;
        this.fileListApp = fileList;
        this.form.MobileDialogsImageUrl = '';
    },
    dealImgChangePc(file, fileList){
        this.hideUploadPc = fileList.length >= this.limitCount;
    },
    //上传成功pc
    handleAvatarSuccessPc(res, file ,fileList) {
        if(res.Result != 1) {
            this.fileListPc = [];
            return this.$message.error(res.Message)
        }
        this.fileListPc = fileList;
        this.form.PcDialogsImageUrl = res.Data[0].imgUrl;
    },
    //删除上传文件pc
    handleDealImgRemovePc(file, fileList){
        this.hideUploadPc = fileList.length >= this.limitCount;
        this.fileListPc = fileList;
        this.form.PcDialogsImageUrl = '';
    },
    //点击图片查看
    handlePictureCardPreview(file) {
        this.dialogImageUrl = '';
        this.dialogImageUrl = file.response?file.response.Data[0].imgUrl : file.url;
        this.dialogVisible = true;
    },
    //清空
    handleReset() {
        this.form = JSON.parse(JSON.stringify(this.oraginForm))
        this.fileListApp = []
        this.fileListPc = []
        this.hideUploadApp = false
        this.hideUploadPc = false
    },
    //提交保存
    onSubmit(type){
        let data = JSON.parse(JSON.stringify(this.form))
        if(!data.Title) {
            return this.$message.warning('弹窗标题不能为空')
        }
        if(!data.DialogsType) {
            return this.$message.warning('请选择弹窗类型')
        }
        if(!data.Content) {
            return this.$message.warning('提醒内容不能为空')
        }
        if(!data.DialogsPage) {
            return this.$message.warning('请选择弹窗页面')
        }
        if(!data.SceneCode) {
            return this.$message.warning('请选择弹窗场景')
        }
        if(!data.Period) {
            return this.$message.warning('请选择提醒频率')
        }
        if(data.Period != 1 && data.Period != 6) {
            if(!data.RemindCount) {
                return this.$message.warning('提醒次数不能为空')
            }
        }
        if(!data.AppIsRemind && !data.PcIsRemind && !data.WxIsRemind) {
            return this.$message.warning('请选择站点')
        }
        if(!data.ConfirmBtnText) {
            return this.$message.warning('交互功能命名不能为空')
        }
        if(data.AppIsRemind || data.WxIsRemind) {
            if(!data.MobileDialogsImageUrl) {
                return this.$message.warning('请上传app及微信站配图')
            }
        }else{
            data.MobileDialogsImageUrl = ''
        }
        if(data.PcIsRemind) {
            if(!data.PcDialogsImageUrl) {
                return this.$message.warning('请上传Pc站配图')
            }
        }else{
            data.PcDialogsImageUrl = ''
        }
        data.OperationType = type
        data.platform = 'pcweb'
        this.submitAllLoading = true
        if(!this.isEditor) {
            addDialogsConfig(data).then(res => {
                this.submitAllLoading = false
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message)
                this.editorShow = false
                this.$emit('onSubmitRefresh')
            })
        }else{
            delete data.RemindFrequency
            delete data.StatusStr
            delete data.Status
            delete data.SiteStr
            delete data.Priority
            delete data.PriorityStr
            delete data.CreateTime
            delete data.CreateTimeStr
            delete data.DialogsTypeStr
            updateDialogsConfig(data).then(res => {
                this.submitAllLoading = false
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message)
                this.editorShow = false
                this.$emit('onSubmitRefresh')
            })
        }
    },
    async listEnumItemFun(){
        let data = {
            EnumNameSpace: 'Gk.FinanceSvcPro.PO.DialogsSceneCode',
            platform: 'pcweb'
        }
        let res = await listEnumItem(data)
        this.sceneCodeList = res.Data
    },
  }
}
</script>
<style lang="scss">
    .item-flex-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }
    .position-right-i {
        position: relative;
        i {
            position: absolute;
            right: 10px;
            top: 0;
            color: #999999;
            font-style: normal;
        }
    }
    .show {
        height: 110px;
        .el-icon-close-tip {
            display: none !important;
        }
        // 取消删除过滤动画
        .el-upload-list__item {
            transition: none !important;
        }
        .el-upload--picture-card{
            width:110px;
            height:110px;
            line-height:110px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width:110px;
            height:110px;
        }
    }
    .hide .el-upload--picture-card {
        display: none;
    }
    
</style>